import type React from 'react';
import classNames from 'classnames';
import { FlexColumn, Gap } from 'ui-components/components/flex';
import { CustomsErrorsSection } from './errors';
import { CustomsWarningSection } from './warnings';
import { CustomsInfo } from './info';

import commonStyle from '../../../components/common-style.module.less';

interface CustomsStatusProps {
  fulfillmentPlanId: string;
}

export const CustomsStatus: React.FC<CustomsStatusProps> = ({ fulfillmentPlanId }) => {
  return (
    <>
      <FlexColumn className={classNames(commonStyle['widget-section'])} gap={Gap.Space8}>
        <CustomsInfo />
      </FlexColumn>
      <FlexColumn className={classNames(commonStyle['widget-section'])} gap={Gap.Space8}>
        <CustomsErrorsSection />
        <CustomsWarningSection fulfillmentPlanId={fulfillmentPlanId} />
      </FlexColumn>
    </>
  );
};
